import urlJoin from 'url-join';

export const MAP_PIN_URL = urlJoin(process.env.NEXT_PUBLIC_APP_DOMAIN || '', '/assets/pin.png');
